import {
  DASHBOARD_CHARTS_CATEGORY_PREMIUM_ENDPOINT,
  DASHBOARD_CHARTS_COMMISSION_ENDPOINT,
  DASHBOARD_CHARTS_PREMIUM_ENDPOINT,
  DASHBOARD_CHARTS_PROPOSAL_ENDPOINT,
  DASHBOARD_CHARTS_RENEWAL_ENDPOINT,
  DASHBOARD_CHARTS_SERVICE_MANAGER_ENDPOINT,
} from "../constants/endpoints";
import { request } from "./request";

export const getProductPremium = async (
  year: string,
  month: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${DASHBOARD_CHARTS_PREMIUM_ENDPOINT}month=${month}&year=${year}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const getCategoryPremium = async (
  year: string,
  category: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${DASHBOARD_CHARTS_CATEGORY_PREMIUM_ENDPOINT}category=${category}&year=${year}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const getProposalCounts = async (
  month: string,
  year: string,
  member: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${DASHBOARD_CHARTS_PROPOSAL_ENDPOINT}month=${month}&year=${year}&&member=${member}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const getCommissionCounts = async (
  month: string,
  year: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${DASHBOARD_CHARTS_COMMISSION_ENDPOINT}month=${month}&year=${year}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const getRenewals = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${DASHBOARD_CHARTS_RENEWAL_ENDPOINT}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const getServiceMangerPerformance = async (
  month: string,
  year: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${DASHBOARD_CHARTS_SERVICE_MANAGER_ENDPOINT}month=${month}&year=${year}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};
